import { getDifferenceBetweenTwoStrings } from 'framework/utils';
import { isEmpty } from 'lodash';

export const ADDITIONAL_CONTACTS_OPTIONS = {
  LinkedIn: 'LinkedIn',
  Telegram: 'Telegram',
  Whatsapp: 'Whatsapp',
  Viber: 'Viber',
  Github: 'Github',
  'Dev.by': 'Dev.by',
  'Jobs.tut.by': 'Rabota.by',
  Stackoverflow: 'Stackoverflow',
  Other: 'Other',
};

const ADDITIONAL_CONTACTS_OPTIONS_ALIAS = Object.keys(ADDITIONAL_CONTACTS_OPTIONS);
const DEFAULT_ADDITIONAL_CONTACTS_OPTIONS_ALIAS = 'Other';

const minMatchLimit = 0.75;

const useAdditionalContactsHelper = () => {
  const getPreparedAdditionalContacts = (contacts: any[]) => {
    if (!contacts || !Array.isArray(contacts)) {
      return [];
    }

    return contacts.map(contact => {
      let newContact = {};
      ADDITIONAL_CONTACTS_OPTIONS_ALIAS.some(type => {
        const diff: any = getDifferenceBetweenTwoStrings(contact.type?.replace(/[ ()]/g, ''), type);

        if (contact.type === type || diff >= minMatchLimit) {
          newContact = { ...contact, type };
          return true;
        }

        return false;
      });

      if (isEmpty(newContact)) {
        return { ...contact, type: DEFAULT_ADDITIONAL_CONTACTS_OPTIONS_ALIAS };
      }

      return newContact;
    });
  };

  return {
    getPreparedAdditionalContacts,
  };
};

export default useAdditionalContactsHelper;
